/**
 * Pushes named interaction events to the GTM dataLayer.
 * Build GTM triggers off the `event` names below.
 * No-ops cleanly if GTM/dataLayer isn't present.
 */
(function () {
  window.dataLayer = window.dataLayer || [];
  function push(event, params) {
    params = params || {};
    // GTM-style dataLayer event
    window.dataLayer.push(Object.assign({ event: event }, params));
    // Direct GA4 (gtag.js) event — fires when GA4 is wired without GTM
    if (typeof window.gtag === 'function') {
      window.gtag('event', event, params);
    }
  }

  function text(el) {
    return (el && el.textContent ? el.textContent : '').trim().replace(/\s+/g, ' ').slice(0, 120);
  }

  document.addEventListener(
    'click',
    function (e) {
      var t = e.target;
      if (!(t instanceof Element)) return;

      var heroBtn = t.closest('.home-banner-btn, .about-hero__btn');
      if (heroBtn) {
        push('hero_cta_click', { cta_text: text(heroBtn), cta_href: heroBtn.getAttribute('href') || '' });
        return;
      }

      var flavorTile = t.closest('.choose-flavor__banner-link, .choose-flavor__banner-button');
      if (flavorTile) {
        var card = t.closest('.choose-flavor__banner');
        push('flavor_tile_click', {
          tile_title: text(card && card.querySelector('.choose-flavor__banner-title')) || text(flavorTile),
          tile_href: flavorTile.getAttribute('href') || '',
        });
        return;
      }

      var recipeCard = t.closest('.recipe-card__link');
      if (recipeCard) {
        push('recipe_card_click', {
          recipe_name: text(t.closest('.recipe-card') && t.closest('.recipe-card').querySelector('.recipe-card__title')),
          recipe_href: recipeCard.getAttribute('href') || '',
        });
        return;
      }

      var productCta = t.closest('.product-cta .btn-cta');
      if (productCta) {
        push('product_cta_click', { cta_text: text(productCta), cta_href: productCta.getAttribute('href') || '' });
        return;
      }

      var addToCart = t.closest('[name="add"], .add-to-cart-button, .product-form-buttons button');
      if (addToCart) {
        push('add_to_cart_click', { source: location.pathname });
        return;
      }

      var social = t.closest('.social-icons__icon-wrapper a, .get-touch__socials a, footer a[aria-label]');
      if (social) {
        push('social_link_click', { network: social.getAttribute('aria-label') || '', href: social.getAttribute('href') || '' });
        return;
      }

      var nav = t.closest('.header__menu a, .header-menu a, [class*="menu"] a');
      if (nav && t.closest('header, #header-group')) {
        push('nav_click', { nav_text: text(nav), nav_href: nav.getAttribute('href') || '' });
        return;
      }

      var footerLink = t.closest('footer a');
      if (footerLink) {
        push('footer_link_click', { link_text: text(footerLink), link_href: footerLink.getAttribute('href') || '' });
        return;
      }
    },
    true
  );

  document.addEventListener(
    'change',
    function (e) {
      var t = e.target;
      if (!(t instanceof Element)) return;
      if (t.matches('#recipe-search-input, .filter-btn, .recipe-filters-dropdown, #cooking-time-filter, #sort-by')) {
        push('recipe_filter_change', {
          filter_control: t.id || t.className,
          filter_value: 'value' in t ? t.value : '',
        });
      }
    },
    true
  );

  document.addEventListener(
    'submit',
    function (e) {
      var form = e.target;
      if (!(form instanceof Element)) return;
      if (form.querySelector('input[type="email"]')) {
        push('email_signup_submit', { form_location: location.pathname });
      }
    },
    true
  );
})();
